import { render, staticRenderFns } from "./AlterDetailTable.vue?vue&type=template&id=6623231e&scoped=true"
import script from "./AlterDetailTable.vue?vue&type=script&lang=js"
export * from "./AlterDetailTable.vue?vue&type=script&lang=js"
import style0 from "./AlterDetailTable.vue?vue&type=style&index=0&id=6623231e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6623231e",
  null
  
)

export default component.exports